<template>
    <div>
        <h4 class="heading-1">
            <span>PROJETO</span>
        </h4>
        <b-row v-if="projeto">
            <b-col sm="12" md="4">
                <app-k-v
                    titulo="Código"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.codProjeto"
                ></app-k-v>
                <app-k-v
                    titulo="Projeto"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.projeto"
                ></app-k-v>
                <app-k-v
                    titulo="Unidade"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.unidade"
                ></app-k-v>
                <app-k-v
                    titulo="Gestor"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.gestor"
                ></app-k-v>
                <app-k-v
                    titulo="Fornecedor"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.credenciado"
                ></app-k-v>
            </b-col>
            <b-col sm="12" md="4">
                <app-k-v
                    titulo="Ficha Técnica"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.fichaTecnica"
                ></app-k-v>
                <app-k-v
                    titulo="Qtd Etapas"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.qtdEtapas"
                ></app-k-v>
                <app-k-v
                    titulo="Total Horas"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.totalHoras"
                ></app-k-v>
                <app-k-v titulo="Valor Total" :md="md" :lg="lg" :xl="xl">
                    <strong>{{ projeto.valorTotal | currency }}</strong>
                </app-k-v>
            </b-col>
            <b-col sm="12" md="4">
                <app-k-v
                    titulo="Descricao Demanda"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.descricaoDemanda"
                ></app-k-v> 
                <app-k-v
                    titulo="Tipo Contratação"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.tipoContratacao"
                ></app-k-v> 
                <app-k-v
                    titulo="Area"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.descricaoArea"
                ></app-k-v> 
                <app-k-v
                    titulo="Sub Area"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.descricaoSubArea"
                ></app-k-v> 
                <app-k-v
                    titulo="Solução"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.descricaoSolucao"
                ></app-k-v> 
            </b-col>
        </b-row>
        <convenioDetalhar
            :projeto="projeto"
        ></convenioDetalhar>
        <h4 class="heading-1 mt-3">
            <span>ETAPA</span>
        </h4>
        <b-row v-if="etapa">
            <b-col sm="12" md="4">
                <app-k-v
                    titulo="Serviço"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="etapa.servico"
                ></app-k-v>
                <app-k-v
                    titulo="Natureza"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="etapa.natureza"
                ></app-k-v> 
                <app-k-v
                    titulo="Modalidade"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="etapa.modalidade"
                ></app-k-v> 
                <app-k-v titulo="Período" :md="md" :lg="lg" :xl="xl"
                    ><strong
                        >{{ $moment(etapa.inicioEtapa).format('DD/MM/YYYY') }} -
                        {{
                            $moment(etapa.terminoEtapa).format('DD/MM/YYYY')
                        }}</strong
                    ></app-k-v
                >
                <app-k-v
                    titulo="Qtd Horas"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="etapa.horasEtapa"
                ></app-k-v>
                <app-k-v
                    titulo="Qtd Horas Realizadas"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong>
                        {{etapa.horasEtapaRealizada > 0 ? etapa.horasEtapaRealizada : 0 }}
                    </strong>
                </app-k-v>
                <app-k-v titulo="Valor Hora" :md="md" :lg="lg" :xl="xl"
                    ><strong>{{ etapa.valorHora | currency }}</strong></app-k-v
                >
                <app-k-v
                    titulo="Qtd Despesas"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong>
                        {{etapa.qtdDespesas > 0 ? etapa.qtdDespesas : 0 }}
                    </strong>
                </app-k-v>
                <app-k-v titulo="Valor Despesas" :md="md" :lg="lg" :xl="xl"
                    ><strong>{{ etapa.valorDespesas | currency }}</strong></app-k-v
                >
                <app-k-v titulo="Valor Total" :md="md" :lg="lg" :xl="xl"
                    ><strong>{{ etapa.valorTotal | currency }}</strong>
                </app-k-v>
            </b-col>
            <b-col sm="12" md="6">
                <app-k-v titulo="Parcela" :md="md" :lg="lg" :xl="xl">
                    <strong>{{ etapa.idEtapa}}</strong>
                </app-k-v>
                <app-k-v titulo="Etapa" :md="md" :lg="lg" :xl="xl">
                    <strong>{{ etapa.idEtapaCliente}}</strong>
                </app-k-v>
                <app-k-v
                    titulo="Status"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <app-status :status="etapa.status"></app-status>
                </app-k-v>
                <app-k-v
                    titulo="Gestor Não Quer Aditivar"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <app-status :status="etapa.naoAditivarDesc"></app-status>
                </app-k-v>
                <app-k-v titulo="Comprometimento" :md="md" :lg="lg" :xl="xl"
                    ><strong>{{ etapa.idMov }}</strong>
                    <status-id-mov :etapa="etapa"></status-id-mov
                ></app-k-v>
                <app-k-v
                    titulo="Registro de Pagamento"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="etapa.pagamento"
                ></app-k-v>
                <app-k-v titulo="Atualizado em" :md="md" :lg="lg" :xl="xl">
                    <strong>{{
                        $moment(etapa.dataAtualizacao).format(
                            'DD/MM/YYYY HH:mm'
                        )
                    }}</strong>
                </app-k-v>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import StatusIdMov from './StatusIdMov'
import convenioDetalhar from '../convenioDetalhar';

export default {
    props: {
        projeto: {
            type: Object,
            default: () => ({})
        },

        etapa: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            xl: 3,
            lg: 3,
            md: 2
        }
    },

    computed: {},

    components: {
        StatusIdMov,
        convenioDetalhar
    }
}
</script>
